"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _input = require("../../input");
var _BlockSubtitle = _interopRequireDefault(require("../../title/BlockSubtitle"));
var _button = require("../../button");
var _StepperMember2 = _interopRequireDefault(require("./StepperMember.style"));
var _StepperValueHeader = _interopRequireDefault(require("./StepperValueHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StepperMember = /*#__PURE__*/function (_React$Component) {
  function StepperMember(props) {
    var _this;
    _classCallCheck(this, StepperMember);
    _this = _callSuper(this, StepperMember, [props]);
    _defineProperty(_this, "onCustomLabelAdd", function () {
      _this.setState({
        isCustomLabel: true
      });
      _this.props.ruleChange({
        label: ''
      });
    });
    _defineProperty(_this, "onCustomLabelRemove", function () {
      _this.setState({
        isCustomLabel: false
      });
      _this.props.ruleChange({
        label: null
      });
    });
    _defineProperty(_this, "onLabelChange", function (event) {
      return _this.props.ruleChange({
        label: event.target.value
      });
    });
    _defineProperty(_this, "onValueChange", function (event) {
      return _this.props.ruleChange({
        value: event.target.value,
        type: 'numeric'
      });
    });
    _this.state = {
      isCustomLabel: !!props.data.label
    };
    return _this;
  }
  _inherits(StepperMember, _React$Component);
  return _createClass(StepperMember, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        labels = _this$props.labels,
        index = _this$props.index,
        data = _this$props.data,
        removeStep = _this$props.removeStep,
        setHasChanges = _this$props.setHasChanges,
        error = _this$props.error;
      var isCustomLabel = this.state.isCustomLabel;
      var buttonAddLabel = index === 0 ? labels.STEP_ADD_DEFAULT_LABEL : labels.STEP_ADD_STEP_LABEL;
      var buttonRemoveLabel = index === 0 ? labels.STEP_REMOVE_DEFAULT_LABEL : labels.STEP_REMOVE_STEP_LABEL;
      return /*#__PURE__*/_react["default"].createElement(_StepperMember2["default"], {
        ruleIndex: index,
        labels: labels
      }, index > 1 && /*#__PURE__*/_react["default"].createElement(_StepperValueHeader["default"], {
        labels: labels,
        ruleIndex: index,
        actions: {
          deleteRuleFormulas: removeStep
        },
        setHasChanges: setHasChanges
      }), /*#__PURE__*/_react["default"].createElement(_BlockSubtitle["default"], {
        className: "stepper-block-title"
      }, index === 0 ? labels.STEP_DEFAULT : labels.STEP_INDEX.replace('%index%', index), /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "stepper-label-toggle",
        type: "link",
        action: isCustomLabel ? this.onCustomLabelRemove : this.onCustomLabelAdd
      }, isCustomLabel ? buttonRemoveLabel : buttonAddLabel)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "stepper-input-group"
      }, isCustomLabel && /*#__PURE__*/_react["default"].createElement("div", {
        className: "stepper-input-container"
      }, /*#__PURE__*/_react["default"].createElement(_input.Input, {
        onChange: this.onLabelChange,
        type: "text",
        placeholder: labels.STEP_DEFAULT_LABEL_PLACEHOLDER,
        value: data.label,
        errors: error && error.label
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "stepper-input-separator"
      }, ":")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "stepper-input-container"
      }, /*#__PURE__*/_react["default"].createElement(_input.Input, {
        onChange: this.onValueChange,
        type: "number",
        value: data.value,
        placeholder: labels.STEP_DEFAULT_VALUE_PLACEHOLDER,
        errors: error && error.value
      }))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = StepperMember;
StepperMember.defaultProps = {
  error: {}
};
StepperMember.propTypes = {
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  index: _propTypes["default"].number.isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  data: _propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  }).isRequired,
  error: _propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  }),
  removeStep: _propTypes["default"].func.isRequired,
  setHasChanges: _propTypes["default"].func.isRequired
};